var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5C9.032 5 5 9.032 5 14C5 18.968 9.032 23 14 23C18.968 23 23 18.968 23 14C23 9.032 18.968 5 14 5ZM14 21.2C10.022 21.2 6.8 17.978 6.8 14C6.8 12.335 7.367 10.805 8.321 9.59L18.41 19.679C17.195 20.633 15.665 21.2 14 21.2ZM19.679 18.41L9.59 8.321C10.805 7.367 12.335 6.8 14 6.8C17.978 6.8 21.2 10.022 21.2 14C21.2 15.665 20.633 17.195 19.679 18.41Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAnswer);
export default __webpack_public_path__ + "static/media/NoAnswer.4b75a3346f2ff5e5eb0557f53cbeb135.svg";
export { ForwardRef as ReactComponent };